// Trophy and theme unlock configuration
// Modify these values to adjust reward amounts and unlock thresholds

// Trophy rewards for different interaction outcomes
export const TROPHY_REWARDS = {
  success: 5,      // Awarded when user chooses "Yes, it was successful"
  difficult: 2,    // Awarded when user chooses "No, I'll try again" (interaction was difficult)
};

// Theme unlock thresholds (total trophies required)
export const THEME_UNLOCKS = {
  calmBlue: 0,        // Blossom (first unlockable theme)
  softMint: 20,       // Mint
  gentleLavender: 40, // Lavender
  forestLights: 60,   // Forest
  snowyTwilight: 90,  // Cherry
  emberGlow: 120,     // Autumn
  cozyEvening: 150,   // Blueberry
  sunnySky: 200,      // Sunny (final theme)
};

